export const Pricing = () => {
  return (
    <div>Here is the pricing page placeholder</div>
  )
}
